import { gql } from '@apollo/client';

export default gql`
  mutation CreateProductMutation($product: ProductInput!) {
    createProduct(input: { product: $product }) {
      product {
        id
        name
      }
    }
  }
`;
